// src/components/FilterBar.js
import React, { useState } from "react";
import "../styles/filterBar.css";

function FilterBar({ onFilterChange }) {
  const [filter, setFilter] = useState("");

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value;
    setFilter(selectedFilter);
    onFilterChange(selectedFilter);
  };

  return (
    <div className="filter-bar">
      <label htmlFor="filter">Sort By:</label>
      <select id="filter" value={filter} onChange={handleFilterChange}>
        <option value="">Select</option>
        <option value="price-low-high">Price: Low to High</option>
        <option value="price-high-low">Price: High to Low</option>
        <option value="alphabetic-asc">Alphabetical: A-Z</option>
        <option value="alphabetic-desc">Alphabetical: Z-A</option>
        <option value="rating-high-low">Rating: High to Low</option>
        <option value="rating-low-high">Rating: Low to High</option>
        <option value="popularity">Most Popular</option>
      </select>
    </div>
  );
}

export default FilterBar;
